import { Button, CircularProgress } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { createSvgIcon } from "@mui/material/utils";
import { useGridApiContext } from "@mui/x-data-grid";
import React from "react";
import { ExportCsvButtonProps } from "./Interfaces/ExportCsvButton.interfaces";

const ExportIcon = createSvgIcon(
  <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z" />,
  "SaveAlt"
);

// Reusable Export CSV Button
export const ExportCsvButton: React.FC<ExportCsvButtonProps> = ({
  fileNamePrefix = "customers-export",
  tooltip = "Export To CSV",
  buttonLabel = "Export",
  onCustomExport,
  isExporting = false
}) => {
  const apiRef = useGridApiContext();
  const buttonBaseProps = {
    color: "primary",
    size: "small",
    startIcon: isExporting ? <CircularProgress size={16} color="inherit" /> : <ExportIcon />
  } as const;

  const handleExport = () => {
    // If custom export handler is provided, use it instead of default CSV export
    if (onCustomExport) {
      onCustomExport();
      return;
    }

    /*
      Example: Exporting DataGrid data as CSV with a custom filename

      The following code uses the DataGrid's apiRef to export the currently visible (filtered/sorted) data as a CSV file.
      The fileName option allows you to specify the name of the downloaded file.
      In this example, the filename will look like: {fileNamePrefix}-2025-05-14-13-45-30.csv
    */
    apiRef.current.exportDataAsCsv({
      fileName: `${fileNamePrefix}-${new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-")}`
    });
  };
  return (
    <Tooltip title={tooltip}>
      <Button {...buttonBaseProps} onClick={handleExport} disabled={isExporting}>
        {isExporting ? "Exporting..." : buttonLabel}
      </Button>
    </Tooltip>
  );
};
